export const VERIFICATION_PRE_SORTIE_TEXT =
  process.env.REACT_APP_VERIFICATION_CODE_ML_PRE_SORTIE_TEXT || '';

export const VERIFICATION_PRE_SORTIE_CHECKBOX_TEXT =
  process.env.REACT_APP_VERIFICATION_CODE_ML_PRE_SORTIE_CHECKBOX_TEXT || '';
